module.exports = __webpack_public_path__ + "static/img/study_load.d38da1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-4/study_load.jpg
// module id = 8SU4
// module chunks = 1